import * as z from "zod"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(z.string(), jsonSchema)]))

export const ConfigurationObjectLinkDbModel = z.object({
  id: z.string(),
  deleted: z.boolean().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  type: z.string().nullish(),
  data: jsonSchema,
  workspaceId: z.string(),
  fromId: z.string(),
  toId: z.string(),
})
